import React from 'react';
import { Table, TablePaginationConfig } from 'antd';
import styled from '@emotion/styled';
import { useTranslation } from 'react-i18next';
import { ShopStatus, ShopType } from '../../../types/shop';
import { PROMOTION } from '../../../constants/define/translation';
import { ActionsColumn, IndexColumn, ShowHideColumn, StatusColumn, TitleColumn } from './columns';
import { appStyles } from '../../../styles';
import CountryColumn from './columns/CountryColumn';
import {
  getScheduleTileWidgetById,
  WIDGET_TYPE,
} from '../../../repository/mytm/schedule-tiles/scheduleTilesRepository';

interface PromotionTableProps {
  records: ShopType[];
  onRefresh: () => void;
  setLoading: (value: boolean) => void;
  setIsOpenModal: Function;
  setIsOpenScheduleModal: Function;
  setDataRecord: Function;
  setDataScheduleRecord: Function;
  loading?: boolean;
  className?: string;
  isDraft?: boolean;
  pagination?: TablePaginationConfig;
}

const { Column } = Table;
export const PromotionTable = (props: PromotionTableProps) => {
  const { t } = useTranslation(PROMOTION);
  const { pagination, records, loading, className, onRefresh, isDraft, setLoading, setDataScheduleRecord } = props;
  const recordActive = records.filter(val => val.status === ShopStatus.ACTIVE);

  const handleGetScheduleWidgetByID = async (widgetId: string) => {
    setLoading(true);
    try {
      const widget = await getScheduleTileWidgetById(widgetId, WIDGET_TYPE.MARQUEE);

      if (!widget) {
        setDataScheduleRecord({ widgetId, widgetType: WIDGET_TYPE.MARQUEE });
      } else {
        setDataScheduleRecord(widget);
      }

      setLoading(false);
      return widget;
    } catch (e) {
      setLoading(false);
      return null;
    }
  };

  return (
    <>
      <StyledTable
        dataSource={records}
        loading={loading}
        className={className}
        rowKey="index"
        pagination={pagination}
        summary={() => {
          return (
            <>
              <Table.Summary.Row>
                <Table.Summary.Cell index={0}>Total: {records.length}</Table.Summary.Cell>
              </Table.Summary.Row>
            </>
          );
        }}
      >
        <Column
          title={t('table.title.index')}
          align="center"
          width={32}
          dataIndex="index"
          key="index"
          render={value => <IndexColumn value={value} />}
        />
        {!isDraft && (
          <Column
            title={t('table.title.show')}
            align="center"
            width={32}
            dataIndex="show"
            key="show"
            render={(_, record: ShopType) => (
              <ShowHideColumn countRecord={recordActive.length} onRefresh={onRefresh} record={record} />
            )}
          />
        )}
        <Column
          title={t('table.title.country')}
          align="center"
          width={80}
          dataIndex="title"
          key="title"
          render={(_, record: ShopType) => <CountryColumn record={record} />}
        />
        <Column
          title={t('table.title.imageVideo')}
          align="center"
          width={100}
          dataIndex="title"
          key="title"
          render={(_, record: ShopType) => <TitleColumn record={record} />}
        />
        <Column
          title={t('table.title.status')}
          align="center"
          width={62}
          dataIndex="status"
          key="status"
          render={(_, record: ShopType) => (
            <StatusColumn
              status={record.status && record.status === ShopStatus.ACTIVE ? ShopStatus.ACTIVE : ShopStatus.INACTIVE}
              isActive={!!(record.status && record.status === ShopStatus.ACTIVE)}
              width="120px"
            />
          )}
        />
        <Column
          title={t('table.title.action')}
          align="left"
          key="action"
          width={100}
          render={(_, record: ShopType) => (
            <ActionsColumn
              handleGetScheduleWidgetByID={handleGetScheduleWidgetByID}
              record={record}
              {...props}
              setLoading={setLoading}
            />
          )}
        />
      </StyledTable>
    </>
  );
};

const StyledTable = styled(Table)`
  .ant-table-thead {
    border-bottom: 2px solid #eee;
    & > th > tr {
      ${appStyles.background.tableBgGray}
      text-transform: uppercase;
      font-size: 0.75rem;
      font-weight: 600;
      border: 1px solid #dededee3;
      &:before {
        display: none;
      }
    }
  }

  .card-name-tiles {
    max-width: 180px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    line-height: 21px;
    max-height: 48px;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }

  & th.action-home {
    text-align: center !important;
  }
`;
